export default __webpack_public_path__ + "static/media/ChickenWhiteSaucePasta.4122a212.png";